import { apiGet } from "../Utils/apiFetch";
import Banner from "./Home/Banner";
import GameMenu from "./Home/GameMenu";
import Layout from "./Layout";
import apiPath from "../Utils/apiPath";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Home = () => {
  const { t } = useTranslation();
  // function extractGamesFromHTML(htmlString) {
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(htmlString, "text/html");
  //   const cards = doc.querySelectorAll(".slot-game-card");

  //   const games = [];
  //   const seen = new Set();

  //   cards.forEach((card) => {
  //     const nameEl = card.querySelector("[game-name]");
  //     const imgEl = card.querySelector(".slot-game-image-box .v-image__image");

  //     if (!nameEl || !imgEl) return;

  //     const name = nameEl.getAttribute("game-name");
  //     const style = imgEl.getAttribute("style") || "";
  //     const match = style.match(/url\((?:&quot;|"|')?(.*?)(?:&quot;|"|')?\)/);
  //     const image = match ? match[1] : null;

  //     // skip empty autofill placeholder cards (no image, height:0)
  //     if (!image) return;

  //     const key = `${name}|${image}`;
  //     if (seen.has(key)) return;
  //     seen.add(key);

  //     games.push({ name, image,key:"SMARTSOFT" });
  //   });

  //   return games;
  // }
  // const games = extractGamesFromHTML(``);
  // console.log(games);

  const [list, setList] = useState([]);
  const navigate = useNavigate();
  const getWidgets = async () => {
    const { status, data: response_users } = await apiGet(apiPath.matchList, {
      type: "in_play",
    });
    if (status === 200) {
      if (response_users?.success) {
        setList(
          response_users?.results?.filter((res) => {
            return res?.status == "in_play";
          }),
        );
      }
    }
  };

  useEffect(() => {
    getWidgets();
  }, []);

  console.log(list, "list");
  return (
    <Layout>
      <div className="bg_home">
        <Banner />
        <GameMenu />
        <div
          data-v-37235055
          className="highlight-container referral-home-banner-height d-flex"
        >
          <div data-v-37235055 className="highlight-wrapper pt-4">
            <div data-v-37235055 className="third-row-container">
              <div data-v-37235055>{t("ReferralProgram")}</div>
            </div>
            <div
              data-v-37235055
              className="matches-box first_box_match"
              style={{ "overflow-x": "hidden" }}
            >
              <a
                data-v-37235055
                href="/referral/summary"
                className
                style={{ cursor: "pointer" }}
              >
                <img
                  data-v-37235055
                  alt={t("Referral")}
                  src="/static/image/referral/en/refer_mobile.jpg"
                  className="referral_img"
                />
              </a>
            </div>
            {/**/}
          </div>
        </div>
        <div className="highlight-container px-4 py-6">
          <div className="highlight-wrapper">
            <div className="matches-box">
              {list?.map((res) => {
                return (
                  <div>
                    <div className="matchUp">
                      <div>{t("Live")}</div>
                      <img width={70} src="/static/image/favourite/now.webp" />
                    </div>
                    <Link to="/casino?type=cricket" className="match-item mr-5">
                      <div className="league-name">{res?.seriesName}</div>
                      <div className="match-date">
                        {moment(res?.eventDateTime).format(
                          "YYYY-MM-DD HH:MM:SS",
                        )}
                      </div>
                      <div className="match-team">
                        <div className="home-team">
                          <div> {res?.eventName?.split(" v ")[0]}</div>
                          {/* <div>1.31</div> */}
                        </div>
                        <div className="away-team">
                          <div>{res?.eventName?.split(" v ")[0]}</div>
                          {/* <div>3.70</div> */}
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* <div
          className="v-image v-responsive jyTvClass theme--light"
          onclick="window.open('https://winx9.tv/', '_blank')"
          style={{ height: "70px", width: "72px" }}
        >
          <div
            className="v-responsive__sizer"
            style={{ "padding-bottom": "105.521%" }}
          />
          <div
            className="v-image__image v-image__image--cover"
            style={{
              "background-image":
                'url("https://winx9.ne/static/image/home/joyatv.gif")',
              "background-position": "center center",
            }}
          />
          <div className="v-responsive__content" />
        </div> */}
        {/* <div
          className="v-image v-responsive wofClass theme--light"
          style={{ height: "70px", width: "72px" }}
        >
          <div
            className="v-responsive__sizer"
            style={{ "padding-bottom": "105.521%" }}
          />
          <div
            className="v-image__image v-image__image--cover"
            style={{
              "background-image":
                'url("/assets/images/6225b727c2867.gif")',
              "background-position": "center center",
            }}
          />
          <div className="v-responsive__content" />
        </div> */}
      </div>
    </Layout>
  );
};

export default Home;
